import { createAsyncThunk } from '@reduxjs/toolkit';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import { selectTrayUserToken } from '../selectors';
import client from '../../../services/api-client';

export default createAsyncThunk('connectionManager/createTraySolutionInstance', async (payload, { getState }) => {
  const { solutionId, instanceName, accountId } = payload;
  const state = getState();
  const apiBaseUrl = selectApiBaseUrl(state);
  const trayUserToken = selectTrayUserToken(state);

  const url = `${apiBaseUrl}/workflows/create-solution-instance/${trayUserToken}`;

  const response = await client(url, {
    body: {
      accountId,
      solutionId,
      instanceName,
      enabled: false,
    },
  });

  return response?.data?.createSolutionInstance?.solutionInstance;
});
